import { useForm } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { FormInput } from '@/components/ui/form-fields/form-input';
import { FormMaskedInput } from '@/components/ui/form-fields/form-mask-input';
import { useDynamicCreate } from '@/services/dynamic-resource';

interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  documentNumber: string;
}

interface NewCustomerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated: (customer: Customer) => void;
}

/** Modal simples pra cadastrar cliente sem sair do assistente de pedido. */
export function NewCustomerModal({
  open,
  onOpenChange,
  onCreated,
}: NewCustomerModalProps) {
  const { mutate: create, isPending } = useDynamicCreate('customers');

  const form = useForm<{
    name: string;
    email: string;
    phone: string;
    documentNumber: string;
  }>({
    defaultValues: { name: '', email: '', phone: '', documentNumber: '' },
  });

  const handleSubmit = form.handleSubmit((data) => {
    create(data, {
      onSuccess: (created: any) => {
        onCreated(created);
        form.reset();
        onOpenChange(false);
      },
    });
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Novo cliente</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="grid grid-cols-12 gap-4">
          <FormInput
            name="name"
            control={form.control}
            label="Nome"
            required
            sm={12}
            md={12}
            lg={12}
          />
          <FormInput
            name="email"
            control={form.control}
            label="Email"
            sm={12}
            md={12}
            lg={12}
          />
          <FormMaskedInput
            name="phone"
            control={form.control}
            label="Telefone"
            required
            mask={['(99) 9999-9999', '(99) 99999-9999']}
            sm={12}
            md={12}
            lg={12}
          />
          <FormMaskedInput
            name="documentNumber"
            control={form.control}
            label="CPF/CNPJ"
            required
            mask={['999.999.999-99', '99.999.999/9999-99']}
            sm={12}
            md={12}
            lg={12}
          />
        </form>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="success"
            disabled={isPending}
            onClick={handleSubmit}
          >
            Salvar cliente
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
